import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-priceCut",
  "use": "icon-priceCut-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-priceCut\"><defs><style type=\"text/css\"></style></defs><path d=\"M659.418 710.326h223.835c8.502 0 23.528-8.715 29.326-14.845 2.945-1.518-2.278 2.337 0 0 6.162-6.225 16.82-20.461 16.15-29.204l-0.06-194.297c0-16.82-13.693-30.51-30.51-30.51s-30.508 13.691-30.508 30.51v123.892L588.41 322.417c-5.767-5.601-13.327-8.743-21.34-8.743-1.398 0-2.796 0.091-3.705 0.258-7.772 0.986-13.237 3.386-17.822 7.18L329.845 499.94 146.963 322.356c-10.837-10.671-32.636-10.2-43.14 0.576-11.719 12.067-11.385 31.406 0.668 43.155l201.885 196.028c4.373 4.22 9.776 7.103 14.877 7.923 3.127 0.667 5.16 0.88 7.225 0.88 7.165 0 14.36-2.55 19.733-6.982l216.426-179.48 270.467 264.908H659.418c-16.79 0-30.48 13.632-30.48 30.451s13.69 30.511 30.48 30.511\" p-id=\"693\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/priceCut.svg
// module id = kunW
// module chunks = 118